import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { observer } from 'mobx-react';
import moment from 'moment';
import { Tooltip } from '@mui/material';

import LeadsTable from '../../../../components/Leads/components/LeadsTable';
import PageContent from '../../../../components/PageContent';
import { LeadsTableType } from '../../../../components/Leads/components/LeadsTable/utils';
import { AllLeadStates, SalesStage } from '../../../../Model/Lead';
import ISDashboardTabs from '../LeadsTableSection/tabs';
import { DateValueText } from '../../styles';
import { getDateStatusColor, sortLeadsByDateField } from '../dateStatusUtils';
import { DateFormat } from '../../../../../utils/date';

import texts from './texts.json';

const hiddenColumns = ['submitDate', 'lastContactedAt', 'salesStage'];

const PaymentPending = ({
  coachesList,
  setSelectedLead,
  setShowQuestionsModal,
  onOnboardingLinkClick,
  onNotesClick,
  leads,
  userId,
  userName,
}) => {
  const sortedLeads = useMemo(() => (
    sortLeadsByDateField(leads, 'startDate')
  ), [leads]);

  const extraColumns = useMemo(
    () => [
      {
        field: 'startDate',
        headerName: texts.startDate,
        flex: 15,
        valueGetter: ({ row }) => row.startDate,
        renderCell: ({ value }) => {
          const color = getDateStatusColor(value);
          const formattedStartDate = value
            ? moment(value.toDate()).format(DateFormat.DATE_MONTH_YEAR_TIME_SHORT_DISPLAY_FORMAT)
            : texts.empty;
          return (
            <Tooltip title={formattedStartDate} enterDelay={0} arrow>
              <DateValueText $color={color}>
                {`${value ? moment(value.toDate()).fromNow() : texts.empty}`}
              </DateValueText>
            </Tooltip>
          );
        },
      },
      {
        field: 'contractCreatedAt',
        headerName: texts.contractCreatedAt,
        flex: 15,
        valueFormatter: ({ value }) => (
          value ? moment(value.toDate()).fromNow() : texts.empty
        ),
      },
    ],
    [],
  );

  return (
    <PageContent>
      <LeadsTable
        rows={sortedLeads}
        selectLead={setSelectedLead}
        setShowQuestionsModal={setShowQuestionsModal}
        onOnboardingLinkClick={onOnboardingLinkClick}
        selectedLeadStates={AllLeadStates}
        selectedSalesStages={[SalesStage.PAYMENT_PENDING]}
        type={LeadsTableType.IS_LEADS}
        userId={userId}
        userName={userName}
        onNotesClick={onNotesClick}
        coachesList={coachesList}
        activeSalesStageFilter={ISDashboardTabs.PAYMENT_PENDING}
        hiddenColumns={hiddenColumns}
        extraColumns={extraColumns}
        isDisableStatusChange
        showLoadMoreControl={false}
      />
    </PageContent>
  );
};

PaymentPending.propTypes = {
  setSelectedLead: PropTypes.func.isRequired,
  setShowQuestionsModal: PropTypes.func.isRequired,
  onOnboardingLinkClick: PropTypes.func.isRequired,
  onNotesClick: PropTypes.func.isRequired,
  coachesList: PropTypes.object,
  leads: PropTypes.array.isRequired,
  userId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};

PaymentPending.defaultProps = {
  coachesList: {},
};

export default compose(observer)(PaymentPending);
